import { Reference } from "../domain/inventory";
import { getMainImagesWebService } from "../infrastructure/services/getMainImagesWebService";
import { tokenValidation } from "@/business/auth/application/tokenValidation";

export const getMainImagesWeb = {
    async execute(): Promise<Reference[]> {
        return await getMainImagesWebService.execute(await tokenValidation.execute());
    },
};


